export default __webpack_public_path__ + "static/media/block-riparian.b9db8e90.svg";